<script setup lang="ts">
    import { reactive } from 'vue';
    import { markAccountForDeletion } from '@cwd/Views/BackOffice/Account/Account.access';
    import FormInput from '@shared/components/Form/FormInput.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { bsAlert, AlertTypes } from '@shared/components/BsAlerts';
    import { useRouter } from 'vue-router';

    const props = defineProps<{
        accountId: string;
        isDeleted: boolean;
    }>();

    const emit = defineEmits(['accountDeleted']);

    const state = reactive<{
        retention: number;
        isLoading: boolean;
    }>({
        retention: 180,
        isLoading: false,
    });

    const router = useRouter();

    async function deleteAccount() {
        state.isLoading = true;
        await markAccountForDeletion(props.accountId, state.retention)
            .then(() => {
                emit('accountDeleted');
                router.push({ name: 'AccountList' });
                bsAlert({ title: 'Deleted', content: 'Account marked for deletion' });
            })
            .catch(() => {
                bsAlert({ title: 'Error', content: 'Something went wrong', type: AlertTypes.Danger });
            })
            .finally(() => {
                state.isLoading = false;
            });
    }
</script>

<template>
    <BsAlert v-if="props.isDeleted" :type="AlertTypes.Info" :dismissible="false" content="This account has been marked for deletion"></BsAlert>

    <template v-else>
        <FormInput class="form-group max-300" v-model:modelValue.number="state.retention" label="Days before actual removal" type="number"></FormInput>

        <div class="form-group">
            <button class="btn btn-danger" v-confirm="{ action: () => deleteAccount() }">Mark account for deletion</button>
        </div>
    </template>
</template>
